export const formatLocalDateInputValue = (date: Date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
};

export const getLocalDateInputValue = (dayOffset = 0, baseDate = new Date()) => {
  const date = new Date(baseDate);
  date.setDate(date.getDate() + dayOffset);

  return formatLocalDateInputValue(date);
};

export const getLocalMonthAgoDateInputValue = (baseDate = new Date()) => {
  const lastDayOfPreviousMonth = new Date(baseDate.getFullYear(), baseDate.getMonth(), 0).getDate();
  const date = new Date(baseDate.getFullYear(), baseDate.getMonth() - 1, Math.min(baseDate.getDate(), lastDayOfPreviousMonth));

  return formatLocalDateInputValue(date);
};
